import axios from 'axios';
import { Action } from 'redux';

import { IRequestAction } from 'redux/root';
import { authenticatedURL, authenticatedGQL } from 'stubs';
import {
  IMembershipCollection,
  IMembershipEdge,
} from 'stubs/graphql/membership';
import { showLoader, hideLoader } from 'redux/loader/actions';

// --------------
// Actions
// --------------
export enum MEMBERSHIP_ACTIONS {
  UPDATE_RETRIEVE_ALL = 'MEMBERSHIP_ACTIONS/UPDATE_RETRIEVE_ALL',
  UPDATE_RETRIEVE_ACTIVE = 'MEMBERSHIP_ACTIONS/UPDATE_RETRIEVE_ACTIVE',
}

// --------------
// Action types
// --------------
export interface IUpdateRetrieveAll
  extends Action<MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ALL> {
  all: IMembershipCollection;
}

export interface IUpdateRetrieveActive
  extends Action<MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ACTIVE> {
  active: IMembershipEdge | null;
}

export type IMembershipActions = IUpdateRetrieveAll | IUpdateRetrieveActive;

// --------------
// Action creators
// --------------

export const retrieveAllMembershipsRequest =
  (): IRequestAction => async (dispatch) => {
    try {
      dispatch(showLoader());
      const query = authenticatedGQL.retrieveAllMemberships;
      const variables = {};
      const res = await axios.post<any>(authenticatedURL, { query, variables });

      const all: IMembershipCollection = res.data.data.retrieveAllMemberships;

      dispatch(updateRetrieveAll(all));
    } catch (e) {
      // Handled by interceptor
    } finally {
      dispatch(hideLoader());
    }
  };

export const updateRetrieveAll = (
  all: IMembershipCollection
): IUpdateRetrieveAll => ({
  type: MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ALL,
  all,
});

export const retrieveActiveMembershipRequest =
  (): IRequestAction => async (dispatch) => {
    try {
      dispatch(showLoader());
      const query = authenticatedGQL.retrieveActiveMembership;
      const variables = {};
      const res = await axios.post<any>(authenticatedURL, { query, variables });

      const active: IMembershipEdge = res.data.data.retrieveActiveMembership;

      dispatch(updateRetrieveActive(active));
    } catch (e) {
      // Handled by interceptor
    } finally {
      dispatch(hideLoader());
    }
  };

export const updateRetrieveActive = (
  active: IMembershipEdge | null
): IUpdateRetrieveActive => ({
  type: MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ACTIVE,
  active,
});
